import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import store from "utils/redux/store";
import { getTenderUmumDetail } from "utils/redux/tenderUmum/tenderUmumActions";
// import LoadingFallback from "components/views/LoadingFallback";
import { getDictionary } from "components/reuseable/handle-language/dictionaries";

// const DaftarKerja = React.lazy(() => import("components/views/DaftarKerja"));
// const Faq = React.lazy(() => import("components/views/Faq"));
const lazyWithRefresh = (importer) =>
  React.lazy(() =>
    importer()
      .then((module) => {
        sessionStorage.removeItem("chunk-load-refresh");
        return module;
      })
      .catch((error) => {
        if (!sessionStorage.getItem("chunk-load-refresh")) {
          sessionStorage.setItem("chunk-load-refresh", "true");
          window.location.reload();
          return new Promise(() => {});
        }

        sessionStorage.removeItem("chunk-load-refresh");
        throw error;
      })
  );

const Home = lazyWithRefresh(() => import("components/views/Home"));
const HubungiKami = lazyWithRefresh(() => import("components/views/HubungiKami"));
// const ProsesPendaftaran = React.lazy(() =>
//   import("components/views/ProsesPendaftaran")
// );
const Registrasi = lazyWithRefresh(() =>
  import("components/views/Registrasi/Registrasi")
);
const DetailTenderUmum = lazyWithRefresh(() =>
  import("components/views/TenderUmum/DetailTenderUmum")
);
const TenderUmum = lazyWithRefresh(() => import("components/views/TenderUmum"));
const Unduh = lazyWithRefresh(() => import("components/views/Unduh"));
const RekananPaktaIntegritas = lazyWithRefresh(() =>
  import("components/views/Registrasi/RekananPaktaIntegritas")
);
const InformasiPendaftaran = lazyWithRefresh(() =>
  import("components/views/Registrasi/InformasiPendaftaran")
);
const KonfirmasiPendaftaran = lazyWithRefresh(() =>
  import("components/views/Registrasi/Konfirmasi/KonfirmasiPendaftaran")
);
const PendaftaranPut = lazyWithRefresh(() =>
  import("components/views/Registrasi/PendaftaranPelakuUsaha/PendaftaranPut")
);
const Login = lazyWithRefresh(() => import("components/views/Login/index"));
const FlyerAdmin = lazyWithRefresh(() => import("components/views/Login/FlyerAdmin"));
const DocumentAdmin = lazyWithRefresh(() => import("components/views/Login/DocumentAdmin"));
const LupaPassword = lazyWithRefresh(() =>
  import("components/views/Login/ResetPassword")
);

// doc: https://reactrouter.com/en/main
const routes = [
  {
    index: true,
    title: "Home",
    path: "/home",
    // element: (
    //   <Suspense }>
    //     <Home />
    //   </Suspense>
    // ),
    element: (
      <Suspense>
        <Home />
      </Suspense>
    ),
    loader: () => {
      return null;
    },
    handle: {
      crumb: () => "Home",
    },
  },
  // {
  //   title: "Proses Pendaftaran",
  //   path: "/proses-pendaftaran",
  //   element: (
  //     <Suspense
  //       fallback={
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             height: "100vh", // Full viewport height for vertical centering
  //           }}
  //         >
  //           <LoadingFallback />
  //         </div>
  //       }
  //     >
  //       <ProsesPendaftaran />
  //     </Suspense>
  //   ),
  //   handle: {
  //     crumb: () => "Proses Pendaftaran",
  //   },
  // },
  // {
  //   title: "Daftar Kerja",
  //   path: "/daftar-kerja",
  //   element: (
  //     <Suspense }>
  //       <DaftarKerja />
  //     </Suspense>
  //   ),
  //   loader: () => {
  //     return null;
  //   },
  //   handle: {
  //     crumb: () => "Daftar Kerja",
  //   },
  // },
  {
    title: "Tender",
    path: "/tender-umum",
    element: <Outlet />,
    loader: () => {
      return null;
    },
    handle: {
      crumb: () => "Tender",
    },
    children: [
      {
        index: true,
        title: "Tender",
        element: (
          <Suspense>
            <TenderUmum />
          </Suspense>
        ),
      },
      {
        title: "Detail Tender",
        path: ":paketId",
        element: (
          <Suspense>
            <DetailTenderUmum />
          </Suspense>
        ),
        loader: async ({ params }) => {
          //fetching data sudah dari pages detailTenderUmum
          // const cekData = await store.dispatch(
          //   getTenderUmumDetail(params?.paketId)
          // );
          // if (cekData) {
          //   return true;
          // }
          return true;
        },
        handle: {
          crumb: () => "Detail Tender",
        },
      },
    ],
  },
  {
    title: "Registrasi",
    path: "/registrasi",
    element: <Outlet />,
    loader: () => {
      return null;
    },
    handle: {
      crumb: async () => {
        const dict = await getDictionary(
          localStorage.getItem("language") || "en"
        );
        return dict.register;
      },
    },
    children: [
      {
        index: true,
        title: "Registrasi",
        element: (
          <Suspense>
            <Registrasi />
          </Suspense>
        ),
      },
      {
        title: "Informasi Pendaftaran Pelaku Usaha (PUT)",
        path: "informasi-pendaftaran",
        element: (
          <Suspense>
            <InformasiPendaftaran />
          </Suspense>
        ),
        loader: () => {
          return null;
        },
        handle: {
          crumb: () => "Informasi Pendaftaran Pelaku Usaha (PUT)",
        },
      },
      {
        title: "Rekanan Pakta Integritas",
        path: "rekanan-pakta-integritas",
        element: (
          <Suspense>
            <RekananPaktaIntegritas />
          </Suspense>
        ),
        loader: () => {
          return null;
        },
        handle: {
          crumb: () => "Rekanan Pakta Integritas",
        },
      },
      {
        title: "Konfirmasi Pendaftaran",
        path: "konfirmasi-pendaftaran",
        element: (
          <Suspense>
            <KonfirmasiPendaftaran />
          </Suspense>
        ),
        loader: () => {
          return null;
        },
        handle: {
          crumb: () => "Konfirmasi Pendaftaran",
        },
      },
      {
        title: "Pendaftaran Pelaku Usaha",
        path: "pendaftaran-put",
        element: (
          <Suspense>
            <PendaftaranPut />
          </Suspense>
        ),
        loader: () => {
          return null;
        },
        handle: {
          crumb: async () => {
            const dict = await getDictionary(
              localStorage.getItem("language") || "en"
            );
            return dict.registerPut1;
          },
        },
      },
    ],
  },
  // {
  //   title: "FAQ",
  //   path: "/faq",
  //   element: (
  //     <Suspense
  //     // fallback={
  //     //   <div
  //     //     style={{
  //     //       display: "flex",
  //     //       justifyContent: "center",
  //     //       alignItems: "center",
  //     //       height: "100vh", // Full viewport height for vertical centering
  //     //     }}
  //     //   >
  //     //     <LoadingFallback />
  //     //   </div>
  //     // }
  //     >
  //       <Faq />
  //     </Suspense>
  //   ),
  //   loader: () => {
  //     return null;
  //   },
  //   handle: {
  //     crumb: () => "FAQ",
  //   },
  // },
  {
    title: "Unduh",
    path: "/unduh",
    element: (
      <Suspense
      // fallback={
      //   <div
      //     style={{
      //       display: "flex",
      //       justifyContent: "center",
      //       alignItems: "center",
      //       height: "100vh", // Full viewport height for vertical centering
      //     }}
      //   >
      //     <LoadingFallback />
      //   </div>
      // }
      >
        <Unduh />
      </Suspense>
    ),
    loader: () => {
      return null;
    },
    handle: {
      crumb: async () => {
        const dict = await getDictionary(
          localStorage.getItem("language") || "en"
        );
        return dict.download;
      },
    },
  },
  {
    title: "Hubungi Kami",
    path: "/hubungi-kami",
    element: (
      <Suspense
      // fallback={
      //   <div
      //     style={{
      //       display: "flex",
      //       justifyContent: "center",
      //       alignItems: "center",
      //       height: "100vh", // Full viewport height for vertical centering
      //     }}
      //   >
      //     <LoadingFallback />
      //   </div>
      // }
      >
        <HubungiKami />
      </Suspense>
    ),
    loader: () => {
      return null;
    },
    handle: {
      crumb: async () => {
        const dict = await getDictionary(
          localStorage.getItem("language") || "en"
        );
        return dict.contactUs;
      },
    },
  },
  {
    index: true,
    title: "Login",
    path: "/login",
    element: (
      <Suspense
      // fallback={
      //   <div
      //     style={{
      //       display: "flex",
      //       justifyContent: "center",
      //       alignItems: "center",
      //       height: "100vh", // Full viewport height for vertical centering
      //     }}
      //   >
      //     <LoadingFallback />
      //   </div>
      // }
      >
        <Login />
      </Suspense>
    ),
    loader: () => {
      return null;
    },
    handle: {
      crumb: () => "Login",
    },
  },
  {
    title: "Flyer Admin",
    path: process.env.REACT_APP_FLYER_ADMIN_PATH || "/internal-flyer-admin",
    element: (
      <Suspense>
        <FlyerAdmin />
      </Suspense>
    ),
    loader: () => null,
    handle: {
      crumb: () => "Flyer Admin",
    },
  },
  {
    title: "Document Admin",
    path: process.env.REACT_APP_DOCUMENT_ADMIN_PATH || "/internal-document-admin",
    element: (
      <Suspense>
        <DocumentAdmin />
      </Suspense>
    ),
    loader: () => null,
    handle: {
      crumb: () => "Document Admin",
    },
  },
  {
    index: true,
    title: "Lupa Password",
    path: "/reset-password",
    element: (
      <Suspense
      // fallback={
      //   <div
      //     style={{
      //       display: "flex",
      //       justifyContent: "center",
      //       alignItems: "center",
      //       height: "100vh", // Full viewport height for vertical centering
      //     }}
      //   >
      //     <LoadingFallback />
      //   </div>
      // }
      >
        <LupaPassword />
      </Suspense>
    ),
    loader: () => {
      return null;
    },
    handle: {
      crumb: () => "Lupa Password",
    },
  },
];

export default routes;
